// src/hooks/useTestingData.ts
import { useState, useEffect, useCallback, useRef } from 'react';
import { getUserStats, hasTestedToday } from '@/lib/firestore';
import { UserStats } from '@/types';

export const useTestingData = (userId: string | undefined) => {
  const [stats, setStats] = useState<UserStats | null>(null);
  const [hasTested, setHasTested] = useState(false);
  const [loading, setLoading] = useState(true);
  const lastFetchedUserId = useRef<string | undefined>();

  const refresh = useCallback(async () => {
    if (!userId) {
      console.log('⚠️ No userId provided to useTestingData');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log('🔄 Fetching stats for user:', userId);
      
      const [userStats, tested] = await Promise.all([
        getUserStats(userId),
        hasTestedToday(userId),
      ]);
      
      console.log('📊 Stats fetched:', { userStats, tested });
      
      setStats(userStats);
      setHasTested(tested);
    } catch (error) {
      console.error('❌ Error fetching testing data:', error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    // Only fetch if userId changed to prevent duplicate calls
    if (userId && userId !== lastFetchedUserId.current) {
      lastFetchedUserId.current = userId;
      refresh();
    }
  }, [userId, refresh]);

  return { stats, hasTested, loading, refresh };
};

